import { Col, Form } from "react-bootstrap"

import { DateType, DateTypeLabel } from "../../../api/Reports/UnmergedRandomResultsReport/DateType"

interface DateTypeSelectionProps {
  selectedType: DateType
  required?: boolean
  onChange: (event: React.ChangeEvent<HTMLSelectElement>) => void
}

function DateTypeSelection(props: DateTypeSelectionProps) {
  const { selectedType, required, onChange } = props

  return (
    <>
      <Form.Label column sm={2} className={required ? "required" : ""}>
        Date Type
      </Form.Label>
      <Col>
        <Form.Control as="select" onChange={onChange} value={selectedType}>
          {Array.from(DateTypeLabel).map(([k, v]) => (
            <option value={k} key={k} selected={k === selectedType}>
              {v}
            </option>
          ))}
        </Form.Control>
      </Col>
    </>
  )
}
DateTypeSelection.defaultProps = {
  required: true,
}
export default DateTypeSelection
